export default __webpack_public_path__ + "static/eric-chevallier-78b7f63357933128e467d1e9ceb17259.jpg";